/*
 * Custom components for Junge.
 * - <color-count>: "Findes i X farver" on product cards. Colors are separate products titled "Name - Color".
 * - <campaign-countdown>: countdown to the campaign end date from theme settings.
 */

const groupKey = (title) => title.slice(0, title.lastIndexOf(' - ')).trim();
const colorName = (title) => title.slice(title.lastIndexOf(' - ') + 3).trim().toLowerCase();

let colorGroupsPromise;

function loadColorGroups() {
  colorGroupsPromise ??= fetch(`${window.Shopify.routes.root}collections/all?view=color-index`)
    .then((response) => {
      if (!response.ok) throw new Error(`color-index request failed: ${response.status}`);
      return response.json();
    })
    .then((titles) => {
      const groups = new Map();
      titles
        .filter((title) => title.includes(' - '))
        .forEach((title) => {
          const key = groupKey(title);
          if (!groups.has(key)) groups.set(key, new Set());
          groups.get(key).add(colorName(title));
        });
      return groups;
    });

  return colorGroupsPromise;
}

class ColorCount extends HTMLElement {
  async connectedCallback() {
    const groups = await loadColorGroups();
    const count = groups.get(this.dataset.key)?.size ?? 0;
    if (count > 1) this.textContent = this.dataset.label.replace('[count]', count);
  }
}

class CampaignCountdown extends HTMLElement {
  connectedCallback() {
    this.end = new Date(this.dataset.end).getTime();
    if (Number.isNaN(this.end)) throw new Error(`campaign-countdown: invalid date "${this.dataset.end}"`);

    this.values = Object.fromEntries(
      [...this.querySelectorAll('[data-unit]')].map((element) => [element.dataset.unit, element])
    );
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));

    if (remaining === 0) {
      clearInterval(this.interval);
      this.closest('[data-campaign]').hidden = true;
      return;
    }

    const parts = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };

    Object.entries(parts).forEach(([unit, value]) => {
      this.values[unit].textContent = String(value).padStart(2, '0');
    });
  }
}

customElements.define('color-count', ColorCount);
customElements.define('campaign-countdown', CampaignCountdown);
